/**
 * Test Error Tracking
 *
 * Utility to test error monitoring system
 * Run in browser console: window.testErrorTracking()
 */

import { logBuffer } from '@/services/api/log-buffer.service';

export function testErrorTracking() {
  console.log('🧪 Testing error tracking system...\n');

  // Test 1: Manual error log
  console.log('1. Testing manual error log...');
  logBuffer.addErrorLog({
    error_type: 'TestError',
    message: 'This is a test error from the console',
    page_url: window.location.pathname,
    severity: 'medium',
    context: {
      test: true,
      timestamp: new Date().toISOString(),
    },
  });
  console.log('   ✅ Manual error logged\n');

  // Test 2: Simulated promise rejection
  console.log('2. Testing unhandled promise rejection...');
  setTimeout(() => {
    Promise.reject(new Error('Test unhandled promise rejection'));
  }, 100);
  console.log('   ⏳ Promise rejection triggered (check in 1 second)\n');

  // Test 3: Simulated React Query error (will be captured if React Query is active)
  console.log('3. Testing critical error log...');
  logBuffer.addErrorLog({
    error_type: 'CriticalTestError',
    message: 'Simulated critical failure',
    page_url: window.location.pathname,
    severity: 'critical',
    stack_trace: new Error().stack,
    context: {
      test: true,
      type: 'critical_simulation',
    },
  });
  console.log('   ✅ Critical error logged\n');

  // Test 4: Flush logs immediately
  console.log('4. Flushing logs to database...');
  logBuffer.flush().then(() => {
    console.log('   ✅ Logs flushed!\n');
    console.log('📊 Check the dashboard in 5 seconds to see new errors!');
    console.log('   Dashboard: http://localhost:5175/performance');
  });
}

// Make it globally available
if (typeof window !== 'undefined') {
  (window as any).testErrorTracking = testErrorTracking;
  console.log('💡 Error tracking test utility loaded!');
  console.log('   Run: testErrorTracking()');
}
